import { render, staticRenderFns } from "./Artbook.vue?vue&type=template&id=6cba27cb"
import script from "./Artbook.vue?vue&type=script&lang=ts"
export * from "./Artbook.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports